var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9499 7.05071C17.3404 7.44123 17.3404 8.07439 16.9499 8.46492L8.46458 16.9502C8.07406 17.3407 7.44089 17.3407 7.05037 16.9502C6.65984 16.5597 6.65984 15.9265 7.05037 15.536L15.5356 7.05071C15.9262 6.66018 16.5593 6.66018 16.9499 7.05071Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9497 16.9502C16.5592 17.3408 15.926 17.3408 15.5355 16.9502L7.05022 8.46496C6.65969 8.07444 6.65969 7.44127 7.05022 7.05075C7.44074 6.66022 8.07391 6.66022 8.46443 7.05075L16.9497 15.536C17.3402 15.9266 17.3402 16.5597 16.9497 16.9502Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modalCloseIcon.2a1d4a7925f74085642451876f067136.svg";
export { ForwardRef as ReactComponent };